// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2dMiA","productName":"Table_productName__1qLE6"};